import React from 'react';
import PropTypes from 'prop-types';
import DeleteButton from './DeleteButton';
import ActionButton from './ActionButton';
import permissionsProvider from '../../../utilities/permissionsProvider';

const EditDeleteButton = ({
    canDelete,
    canEdit,
    confirmDelete,
    deleteItem,
    editItem,
    viewItem,
    itemName,
    showDelete,
    showText,
    acl
}) => {

    const restrictDelete = !canDelete || !permissionsProvider.canDelete(acl);
    const restrictEdit = !canEdit || !permissionsProvider.canEdit(acl);


    return (
        <div>
            <div className="button-wrapper d-inline-block">
                {restrictEdit && viewItem ?
                    (
                        <ActionButton
                            buttonText={showText === true ? 'View' : ''}
                            imgSource="/images/eye.svg"
                            onClick={viewItem}
                        />
                    ) : (
                        <ActionButton
                            buttonText={showText === true ? 'Edit' : ''}
                            imgSource="/images/edit.svg"
                            onClick={editItem}
                            disabled={restrictEdit}
                        />
                    )}
            </div>
            {showDelete &&
            <div className="button-wrapper d-inline-block">
                <DeleteButton
                    confirmDelete={confirmDelete}
                    onClick={deleteItem}
                    itemName={itemName}
                    showText={showText}
                    disabled={restrictDelete}
                />
                </div>
            }
        </div>
    );
}

EditDeleteButton.propTypes = {
    canDelete: PropTypes.bool,
    canEdit: PropTypes.bool,
    confirmDelete: PropTypes.bool,
    deleteItem: PropTypes.func,
    editItem: PropTypes.func,
    itemName: PropTypes.string,
    showText: PropTypes.bool
};

EditDeleteButton.defaultProps = {
    canDelete: true,
    canEdit: true,
    confirm: false,
    itemName: 'record',
    showDelete: true,
    showText: true
}

export default EditDeleteButton;
